export const SET_PERSONALIZED_STOPS = "SET_PERSONALIZED_STOPS";

interface ActionTypes {
  SET_PERSONALIZED_STOPS: any[];
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export function setPersonalizedStops(
  personalizedStops: any[]
): PersonalizedStopActionTypes {
  return {
    type: SET_PERSONALIZED_STOPS,
    payload: personalizedStops,
  };
}

export type PersonalizedStopActionTypes = MessageAction;
